import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import useGTM from 'hooks/useGTM';
import PropTypes from 'prop-types';

import { ModalSto } from '../sto';

const AccountMergeModal = (props) => {
    const { tagEvent } = useGTM();

    const modalType = {
        backgroundMerge: {
            eventType: 'auto_merge_login',
            title: 'modal.account.background.merge',
        },
        registration: {
            eventType: 'auto_merge_registration',
            title: 'modal.account.merge.from.registration',
        },
    };

    useEffect(() => {
        if (props.visible) {
            tagEvent({
                event: modalType[props.modalType].eventType,
                mergedAccounts: props.accounts,
            });
        }
    }, []);

    return (
        <ModalSto
            buttonSize="large"
            modalType="accountMerge"
            okText="general.ok"
            onOk={props.onOk}
            visible={props.visible}
            wrapClassName="account-merge-modal"
        >
            <React.Fragment>
                <div className="account-merge-modal" role="alert">
                    <h1>
                        <FormattedMessage id={modalType[props.modalType].title} />
                    </h1>
                    <p>
                        <FormattedMessage id="modal.account.merge.subtitle" />
                        <span className="visually-hidden">{props.accounts.toString()}</span>
                    </p>
                    <ul className="account-list">
                        {props.accounts.map((account, i) => (
                            <li key={i}> {account} </li>
                        ))}
                    </ul>
                </div>
            </React.Fragment>
        </ModalSto>
    );
};

AccountMergeModal.propTypes = {
    accounts: PropTypes.arrayOf(PropTypes.string).isRequired,
    modalType: PropTypes.oneOf(['registration', 'backgroundMerge']).isRequired,
    onOk: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
};

export default AccountMergeModal;
